
const Header = () => {
    return (
        <div className='flex text-xl font-bold justify-between px-32 py-4 shadow-blue-700 shadow-xl'>
            <div className='hover:text-gray-700'>Dashboard</div>
        </div >
    )
}

export default Header
